import { Button, Flex, Tag, Tooltip, Typography } from 'antd';

import Styles from './styles';
import { ManualClipsList } from '../ManualClipsList';
import { PlusOutlined } from '@ant-design/icons';
import { useClipEventStore } from '../../store/clip.store';
const { Container } = Styles;

export const ManualClips: React.FC = () => {
  const { emit } = useClipEventStore();
  return (
    <Container>
      <Flex justify="space-between">
        <Flex gap={16} align="center">
          <Typography.Title level={3} style={{ margin: 0 }}>
            Sharing Clips
          </Typography.Title>

          <Tooltip title="Currently in Beta — share any and all feedback to concierge@update.ai">
            <Tag color="red">Beta</Tag>
          </Tooltip>
        </Flex>

        <Button
          type="primary"
          onClick={() => emit('changeTab', 'createClip')}
          icon={<PlusOutlined />}
        >
          Create New Clip
        </Button>
      </Flex>

      <ManualClipsList />
    </Container>
  );
};
